import React, { useState, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { Table, InputGroup, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import webcam from "./../../../assets/img/webcam.png";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import {setWithdrawRequestAsync} from '../smartContract/stakeAction';

const WithdrawalRequest = () => {

	const {
		backdrop,
		currentSlots,
		increasePrice,
		withdrawSlots,
		WithdrawBatch,
		WithdrawLimit,
		withdrawSettings,
		notaryCharge,
		goldDeliveryCharge
	} = useSelector((state) => state.stake, shallowEqual);

	const { address } = useSelector((state) => state.etherium, shallowEqual);
	const { user } = useSelector((state) => state.auth, shallowEqual);

	const dispatch = useDispatch();

	let slots = useMemo(
		() => withdrawSlots.slots.filter((slot) => !slot.isRedemed),
		[withdrawSlots]
	);
	const phoneRegExp = /^[0-9]*$/
	const [data, setData] = useState({
		selectedSlot: [],
		slot: [],
		price: 0.0000,
		tokens: 0.00,
		grams: 0.00,
		requestTransferMehtod: "Bank Transfer",
		userGet: "0 USD"
	});

	const [showAddress, setShowAddress] = useState(false)
	const [addBtnClk, setAddBtnClk] = useState(false)
	const [displayMsg, setDisplayMsg] = useState({
		type: "",
		message: ""
	})

	const onWithdrawRequest = (e) => {
		e.preventDefault();
		if(!data.slot.length) {
			setDisplayMsg({type: "error", message: "No slot selected. Select atleast one select to proceed further."})
			return;
		}
		let finalData = {
			tokens: data.tokens,
			grams: data.grams,
			amount: data.price,
			address: address,
			perGramPrice: increasePrice,
			withdrawCharges: withdrawSettings,
			requestTransferMehtod: data.requestTransferMehtod,
			slot: data.slot,
			notaryCharge,
			goldDeliveryCharge
		};
		
		console.log(finalData);

		if(data.requestTransferMehtod === "Gold Delivery") {
			return setShowAddress(true)
		}

		dispatch(setWithdrawRequestAsync(finalData));
	};

	const onSlotChange = (e, slot, i) => {
		if(displayMsg.type) {
			setDisplayMsg({
				type: "",
				message: ""
			})
		}
		if (e.target.checked) {
			let slots = [...data.slot, { ...slot, idx: i }];
			let tokens = data.tokens + slot.tokens;
			let price = ((data.grams + slot.grams) * increasePrice).toFixed(4);
			let grams = slots.reduce((acc, val) => acc += val.grams, 0.00);
			let requestTransferMehtod = grams < 0.2 ? "Bank Transfer" : "Gold Delivery";
			let userGet = grams < 0.2 ? `${price} USD` : `${grams} Gold`
			setData({
				selectedSlot: [...data.selectedSlot, i],
				slot: slots,
				tokens,
				price,
				grams,
				requestTransferMehtod,
				userGet
			});
			if(requestTransferMehtod === "Bank Transfer") {
				setShowAddress(false);
			}
		} else {
			let slots = data.slot.filter(sl => sl.idx !== i);
			let tokens = data.tokens - slot.tokens;
			let price = ((data.grams - slot.grams) * increasePrice).toFixed(4);
			let grams = slots.reduce((acc, val) => acc += val.grams, 0.00);
			let requestTransferMehtod = grams < 0.2 ? "Bank Transfer" : "Gold Delivery";
			let userGet = grams < 0.2 ? `${price} USD` : `${grams} Gold`;
			setData({
				selectedSlot: data.selectedSlot.filter(dt => dt !== i),
				slot: slots,
				tokens,
				price,
				grams,
				requestTransferMehtod,
				userGet
			});
			if(requestTransferMehtod === "Bank Transfer") {
				setShowAddress(false);
			}
		}
	};

	const [url, setUrl] = useState(null);
	const [verify, setVerify] = useState(false);
	const uploadDoc = (e) => {
		setUrl(URL.createObjectURL(e.target.files[0]));
	};

	const verifyModal = () => setVerify(true);
	const verifyModalClose = () => setVerify(false);
	return (
		<div className="row">
			<div className="col-md-12">
				{/* <h4 className="fn_s_20 f-w-400 color_blk mb-4">Request Withdraw</h4> */}
				<Link className="btn_bk bg-img btn-sm fn_s_20 f-w-400" to="/withdrawal">
					Request Withdraw
        </Link>
				<hr />
				<h4 className="fn_s_18 f-w-500 color_blk mb-4">
					Select Gold ID from you want to withdraw
        </h4>
				<div className="mt-0">
					<Table hover responsive className="mb-0 default_table">
						<thead>
							<tr>
								<th>Select</th>
								<th>Gold Id</th>
								<th>Total Gold (GRAMS)</th>
								<th>Gold Acquired (GRAMS)</th>
								<th>Cost of Gold/ 1 Gram (USD)</th>
								<th>Tokens</th>
								<th>Current Value of Tokens</th>
							</tr>
						</thead>
						<tbody>
							{slots.length ? (
								slots.map((slot, i) => (
									<tr key={i}>
										<td>
											<div className="ap_checkbox tblckcbx">
												<input
													id={i}
													key={i}
													type="checkbox"
													name="checkbox"
													className="mr-2 checkbox"
													checked={data.selectedSlot.indexOf(i) !== -1}
													// value={data.selectedSlot === i}
													onChange={(e) => onSlotChange(e, slot, i)}
												/>
												<label></label>
											</div>
										</td>
										<td>{slot.goldPartID}</td>
										<td>{slot.goldPartFromGram}</td>
										<td>{slot.grams}</td>
										<td>{increasePrice}</td>
										<td>{slot.tokens}</td>
										<td>{currentSlots.currentToken}</td>
									</tr>
								))
							) : (
									<tr>
										<td colSpan={7} className="text-center">
											No Record Found
                      </td>
									</tr>
								)}
						</tbody>
					</Table>
				</div>
			</div>
			<div className="col-md-12 mt-10">
				<form className="form def_form frmwtpddng" onSubmit={onWithdrawRequest}>
					<div className="row">
						<div className="col-md-12">
							<div className="mx-520">
								<div className="form-group">
									<label className="form-label">Withdrawal Tokens</label>
									<InputGroup className="mb-3">
										<input
											placeholder="Withdrawal Tokens"
											name="amt"
											type="text"
											className="form-control frrgtpdng120"
											value={data.tokens}
											onChange={() => {}}
										/>
										{/* <InputGroup.Append>
											<InputGroup.Text className="color_red fn_s_16 f-w-400 ">
												MAX 12,781 USD
                      </InputGroup.Text>
										</InputGroup.Append> */}
									</InputGroup>
									{displayMsg.type && displayMsg.message ? (
										<div className="fv-plugins-message-container">
											<div className="fv-help-block">
												{displayMsg.message}
											</div>
										</div>
									) : null}
								</div>
								<div className="row">
									<div className="col-sm-12 mb-5 text-center">
										<label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
											Grams
										</label>
										<OverlayTrigger
										key={"bottom"}
										placement={"bottom"}
										theme="dark"
										overlay={
											<Tooltip id={`tooltip-bottom`}>
												If gold is less than 100 grams, only bank transfer will be done.
												If gold is equal or more than 100 grams, only gold delivery will be done.
											</Tooltip>
										}
									>
										<InfoOutlinedIcon className="color_blue  ml-2" />
									</OverlayTrigger>
										<h4 className="fn_s_16 f-w-500 color_blk">
											{data.grams}
										</h4>
									</div>
								</div>
								<div className="row">
									<div className="col-sm-4 mb-5 text-center">
										<label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
											Transaction Charges
                     					 </label>
										<h4 className="fn_s_16 f-w-500 color_blk">{withdrawSettings.fixedCharge}&nbsp;&nbsp;
                      						{withdrawSettings.chargeType === "PERCENTAGE"
												? "%"
												: withdrawSettings.chargeType === "AMOUNT"
													? withdrawSettings.currencyMethod
													: null}</h4>
									</div>
									<div className="col-sm-4 mb-5 text-center">
										<label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
											Payment By
										</label>
										<h4 className="fn_s_16 f-w-500 color_blk">
											{data.requestTransferMehtod}
										</h4>
									</div>
									<div className="col-sm-4 mb-5 text-center">
										<label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
											You Get
										</label>
										<h4 className="fn_s_16 f-w-500 color_blue">
											{data.userGet}
										</h4>
									</div>
								</div>
							</div>
						</div>

						{
							<div className="col-12">
								<React.Fragment>{showAddress ?
									<div>
										<div className="row">
											<div className="col-12">
												<div className="form-group text-center w-100 ">
													<label className="form-label ">
														Note: You have entered amout of 100 GMS above, so we
														will sent you a Gold to your address.
                     								 </label>
												</div>
											</div>
										</div>
										{!addBtnClk ? <React.Fragment>
											<div className="row justify-content-center">
												<div className="col-xl-7">
													<div className="lightGreenBox">
														<div className="ap_checkbox tblckcbx w-100 text-left checked-blue-text">
															<input
																type="checkbox"
																name="checkbox"
																className="mr-2 checkbox"
															/>
															<label className="fn_s_16 f-w-400">
																{(user.address || "") + ", " + (user.city || "") + ", " + (user.state || "") + ", " + (user.country || "")}
                          									</label>
														</div>
														<hr />
														{/* <div className="ap_checkbox tblckcbx w-100 text-left checked-blue-text">
															<input
																type="checkbox"
																name="checkbox"
																className="mr-2 checkbox"
															/>
															<label className="fn_s_16 f-w-400">
																1245, lorem ipsum, areaname, New York, New York,
																United States.
                          									</label>
														</div> */}
													</div>
													<div className="text-right mt-3">
														<button
															type="button"
															className="btn btn-def btn-defv3 uppercase"
															onClick={() => setAddBtnClk(true)}
														>
															Add New
                       									 </button>
													</div>
												</div>
											</div>
										</React.Fragment> : null} </div>
									: null}

									{addBtnClk && showAddress ?
										<React.Fragment>
											<div className="row justify-content-center">
												<div className="col-xl-7">
													<div className="lightGreenBox">
														<div className="row">
															<div className="col-md-6">
																<div className="form-group">
																	<label className="form-label">Country</label>
																	<select className="form-control transparent wtblcar_v2 ">
																		<option value="">Select Type</option>
																		<option>United States</option>
																		<option>India</option>
																	</select>
																</div>
															</div>
															<div className="col-md-6">
																<div className="form-group">
																	<label className="form-label">State</label>
																	<input
																		placeholder="Enter State"
																		type="text"
																		className="form-control transparent"
																	/>
																</div>
															</div>
															<div className="col-md-6">
																<div className="form-group">
																	<label className="form-label">City</label>
																	<select className="form-control transparent wtblcar_v2 ">
																		<option value="">Select Type</option>
																		<option>New York</option>
																		<option>Ahmedabad</option>
																	</select>
																</div>
															</div>
															<div className="col-md-6">
																<div className="form-group">
																	<label className="form-label">Address</label>
																	<input
																		placeholder="Enter Address"
																		type="text"
																		className="form-control transparent"
																	/>
																</div>
															</div>
															<div className="col-md-12 d-flex flex-column-sm align-items-center">
																<div className="form-group w-100-verify">
																	<label className="form-label">
																		Address Proof
                              										</label>
																	<div className="d-flex align-items-center justify-content-between formControlUpload  w-100">
																		{url ? (
																			<div className="fn_s_16 text-break w-100-upload">
																				{url}
																			</div>
																		) : (
																				<div className="fn_s_16 opacity30 w-100-upload">
																					Select file
																				</div>
																			)}
																		<label className="uploadBtn">
																			<input type="file" onChange={uploadDoc} />
																			Upload
																		</label>
																	</div>
																</div>
																<button
																	type="button"
																	className="btn btn-def btn-defv3 uppercase ml-3"
																	onClick={verifyModal}
																>
																	Verify
                            									</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</React.Fragment> : null}
								</React.Fragment>
							</div>}
						<div className="col-md-12 text-center pt-5">
							<button type="submit" className="btn btn-def btn-defv4 uppercase">
								Submit
              </button>
						</div>
					</div>
				</form>
			</div>
			<Modal
				show={verify}
				onHide={verifyModalClose}
				centered
				size="lg"
				className="def_modal"
			>
				<Modal.Header closeButton>
					<Modal.Title className="fn_s_18 color_blk f-w-700">
						Verify Your Identity
          </Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col lg={4}>
							<div className="pb-2 fn_s_14 color_blk f-w-400 opacity70">
								Uploaded Document
              </div>
							<img src={url} alt="Document" className="documentImg mb-3" />
						</Col>
						<Col lg={8}>
							<img src={webcam} alt="" className="documentImg mb-3" />
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</div>
	);
};
export default WithdrawalRequest;
